'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MODULE_NAME = 'js-Accordion';
// import { slideDown, slideUp } from '../utils'


var selectors = {
  ITEM: '.' + MODULE_NAME + '_Item',
  TRIGGER: '.' + MODULE_NAME + '_Trigger',
  BODY: '.' + MODULE_NAME + '_Body'
};

var Accordion = function () {
  function Accordion(el) {
    (0, _classCallCheck3.default)(this, Accordion);

    this.el = el;
    this.isAnimating = false;
    this.els = this.getEls();
    this.config = this.getConfig();
    this.setupListeners();
    this.setScrollingHeights();
    this.init();
  }

  (0, _createClass3.default)(Accordion, [{
    key: 'init',
    value: function init() {
      if (this.config.initialState === 'closedButFirstOpen') {
        this.els.items[0].setAttribute('aria-expanded', 'true');
      }
    }
  }, {
    key: 'setScrollingHeights',
    value: function setScrollingHeights() {
      this.els.items.forEach(function (item) {
        var itemBody = item.querySelector(selectors.BODY);
        itemBody.style.setProperty('--clientHeight', itemBody.scrollHeight + 'px');
      });
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.listeners = new _listeners.Listeners();
      this.els.items.forEach(function (item) {
        return _this.listeners.add(item, 'click', function (e) {
          return _this.onTriggerClick(e);
        });
      });
    }
  }, {
    key: 'onTriggerClick',
    value: function onTriggerClick(event) {
      var _this2 = this;

      if (event.target.matches(selectors.TRIGGER) === false || this.isAnimating) {
        return;
      }

      var targetItem = event.target.closest(selectors.ITEM);
      this.toggleOpenState(targetItem);

      if (this.config.openOneAtATime) {
        this.els.items.filter(function (item) {
          return item !== targetItem;
        }).forEach(function (item) {
          return _this2.toggleOpenState(item, true);
        });
      }
    }
  }, {
    key: 'toggleOpenState',
    value: function toggleOpenState(el) {
      var openOneAtATime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // const itemBody = el.querySelector(selectors.BODY)
      var isOpen = el.getAttribute('aria-expanded');
      // this.isAnimating = true

      if (isOpen === 'false' && !openOneAtATime) {
        el.setAttribute('aria-expanded', 'true');
        // slideDown(itemBody, this.getBodyHeight(itemBody)).then(() => {
        //   this.isAnimating = false
        // })
      } else {
        el.setAttribute('aria-expanded', 'false');
        // slideUp(itemBody, this.getBodyHeight(itemBody)).then(() => {
        //   itemBody.removeAttribute('style')
        //   el.setAttribute('aria-expanded', 'false')
        //   this.isAnimating = false
        // })
      }
    }
  }, {
    key: 'getBodyHeight',
    value: function getBodyHeight(el) {
      el.style.display = 'block';
      var style = window.getComputedStyle(el);
      var height = el.offsetHeight + parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
      el.style.display = '';

      return height;
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return {
        initialState: this.el.dataset.initialState,
        openOneAtATime: this.el.dataset.openOneAtATime === 'true'
      };
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;
      return {
        items: (0, _functional.getElements)('.' + MODULE_NAME + '_Item', { context: context })
      };
    }
  }]);
  return Accordion;
}();

var init = exports.init = function init(_ref) {
  var el = _ref.el;

  return new Accordion(el);
};